import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import { ellipsisMultiline } from '../../../utils/mixins';

const StyledPressNote = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: ${rem('425px')};
`;

const StyledName = styled.div`
  background-color: transparent;
  border-top: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  color: ${props => props.theme.colors.grayDarker};
  display: block;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  line-height: 1.6;
  padding: ${rem('6px')} ${rem('24px')} ${rem('6px')} 0;
  width: 100%;
  &:first-child {
    border: none;
  }
`;

const StyledWrapper = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  display: flex;
  height: ${rem('53px')};
  overflow: hidden;
  width: 100%;

  &:nth-child(8n + 1) {
    ${StyledName} {
      border: none;
    }
  }
`;

const StyledNumber = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLighter};
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.gray};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  justify-content: center;
  width: ${rem('53px')};
`;

const StyledLogo = StyledNumber.extend`
  background-color: transparent;
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
`;

const StyledData = styled.div`
  align-items: center;
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  color: ${props => props.theme.colors.grayDarker};
  display: flex;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  justify-content: left;
  justify-content: left;
  padding: 0 ${rem('15px')};
  &:last-child {
    border-bottom: ${rem('1px')} solid
      ${props => props.theme.colors.grayLighter};
  }
`;

const StyledLink = styled.a`
  color: ${props => props.theme.colors.dark};
  padding: ${rem('6px')} ${rem('10px')};
  font-size: ${rem('14px')};

  ${ellipsisMultiline('40px', '1.2em')};
`;

const StyledIcon = styled(Icon)`
  width: ${rem('25px')};
`;

const StyledDate = styled.time`
  width: auto;
`;

export {
  StyledPressNote,
  StyledWrapper,
  StyledNumber,
  StyledLogo,
  StyledName,
  StyledData,
  StyledLink,
  StyledIcon,
  StyledDate
};
